module.exports = __webpack_public_path__ + "static/media/afiliacion_mepal.bc6cc23c.svg";